export const STATIC_CLASSES = Object.freeze({
	bgImage: 'banner2-bg-image',
	root: 'banner2',
	grid: 'banner2-image-container',
	contentWrapper: 'banner2-content',
	content: 'banner2-content',
	textTop: 'banner2-text-block-top',
	mobileImage: 'banner2-image-mobile',
	textBottom: 'banner2-text-block-bottom',
	buttonWrapper: 'banner2-button-wrapper',
	buttonRoot: 'banner2-button-root',
})
